const ShimmerSubCatalogue = ({ sections = 2, itemsPerSection = 4 }) => {
  return (
    <div className="md:space-y-10 p-4 animate-pulse">
      
      {/* Page Header */}
      <div className="sm:mb-6 mb-3">
        <div className="h-6 w-72 bg-slate-200 rounded mb-2"></div>
        <div className="h-4 w-96 bg-slate-200 rounded"></div>
      </div>

      {[...Array(sections)].map((_, i) => (
        <section
          key={i}
          className="overflow-hidden rounded-lg border border-slate-100 bg-white shadow-sm"
        >
          {/* Catalogue Header */}
          <div className="px-4 py-4 sm:px-6 bg-slate-300">
            <div className="h-5 w-40 bg-slate-400 rounded mb-2"></div>
            <div className="h-3 w-32 bg-slate-400 rounded"></div>
          </div>

          <div className="space-y-6 p-4 sm:p-6">
            {[...Array(2)].map((_, j) => (
              <div
                key={j}
                className="rounded-2xl border border-slate-100 bg-slate-50/70 p-3 sm:p-4"
              >
                {/* Subcategory Header */}
                <div className="mb-3 flex justify-between">
                  <div className="h-4 w-32 bg-slate-200 rounded"></div>
                  <div className="h-6 w-16 bg-slate-200 rounded-full"></div>
                </div>

                {/* Items */}
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                  {[...Array(itemsPerSection)].map((_, k) => (
                    <div
                      key={k}
                      className="flex flex-col sm:flex-row overflow-hidden rounded-2xl border border-slate-200 bg-white"
                    >
                      {/* Image */}
                      <div className="h-44 w-full bg-slate-200 sm:h-36 sm:w-36"></div>

                      {/* Content */}
                      <div className="flex-1 p-3 space-y-2">
                        <div className="h-3 w-3/4 bg-slate-200 rounded"></div>
                        <div className="h-3 w-1/2 bg-slate-200 rounded"></div>

                        {/* Price */}
                        <div className="flex gap-2">
                          <div className="h-4 w-16 bg-slate-200 rounded"></div>
                          <div className="h-3 w-12 bg-slate-200 rounded"></div>
                        </div>

                        {/* Delivery */}
                        <div className="h-3 w-24 bg-slate-200 rounded"></div>

                        {/* Buttons */}
                        <div className="flex gap-2 mt-2">
                          <div className="flex-1 h-8 bg-slate-200 rounded"></div>
                          <div className="h-8 w-8 bg-slate-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default ShimmerSubCatalogue;